/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountEmail.defs.js'
export { main as default } from './updateAccountEmail.defs.js'
